import axios from "axios";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import { ConfirmDialog } from "primereact/confirmdialog";
import { FileUpload } from "primereact/fileupload";
import { Image } from "primereact/image";
import P from "../../pics/pdf.svg";

const SegmentProof = ({
  setSegmentFile,
  segmentFile,
  docType,
  activeSegment,
  setSegError,
  msg,
  segmentPreview,
  getSegmentProofData,
  setSegmentPreview,
  segmentName,
  setSegmentName,
}) => {
  const [displaySegment, setDisplaySegment] = useState(false);
  const [displayPosition, setDisplayPosition] = useState(false);
  const [position, setPosition] = useState("center");
  const userCode = sessionStorage.getItem("userCode");
  const URL = process.env.REACT_APP_BASE_URL;
  const [displayPreview, setDisplayPreview] = useState(false);
  const [visible, setVisible] = useState(false);
  const [bUpload, setBUpload] = useState("");

  const invoiceUploadHandler = (files) => {
    uploadInvoice(files.files);
    onHide("displaySegment");
  };

  const uploadInvoice = async (files, invoiceFile) => {
    var myHeaders = new Headers();
    var formdata = new FormData();
    formdata.append("UserCode", userCode);
    formdata.append("ProofName", docType);
    files.forEach((element) => {
      formdata.append("ProofDocument", element);
    });
    setSegmentFile(formdata);
    setBUpload(formdata);
  };
  const dialogFuncMap = {
    displaySegment: setDisplaySegment,
    displayPosition: setDisplayPosition,
    displayPreview: setDisplayPreview,
  };
  const onClick = (name, position) => {
    dialogFuncMap[`${name}`](true);

    if (position) {
      setPosition(position);
    }
  };

  const onHide = (name) => {
    dialogFuncMap[`${name}`](false);
  };
  const onShowSegPop = () => {
    if (docType.length == 0) {
      setSegError("Please Select document type first.");
      return;
    } else {
      onClick("displaySegment");
    }
  };

  const delSegmentProofData = async () => {
    try {
      await axios.post(
        `${URL}/SegmentDetail/removeSegmentProof`,
        {
          userCode: userCode,
        },
        { withCredentials: true }
      );
      setSegmentPreview("");
      setSegmentName("");
      onHide("displayPreview");
    } catch (error) {
      console.log("error in segment data", error);
    }
  };

  useEffect(() => {
    getSegmentProofData();
  }, []);

  const chooseOptions = { label: "Browse" };
  const uploadOptions = {
    label: "Upload",
    icon: "pi pi-upload",
    className: "p-button-success",
  };
  const cancelOptions = {
    label: "Cancel",
    icon: "pi pi-times",
    className: "p-button-danger",
  };

  const handleClick = () => {
    setVisible(true);
  };

  const finalWord = docType
    ?.toLowerCase()
    .split("-")
    ?.map((word) => {
      return word[0]?.toUpperCase() + word?.substring(1);
    })
    .join(" ");

  return (
    <>
      <div className="segment_btn">
        <Button
          icon={segmentFile ? null : "pi pi-file"}
          label={segmentFile == "" ? "Upload Documents" : "Document Uploaded"}
          className="p-button-outlined p-button-sm "
          onClick={onShowSegPop}
          style={{ marginBottom: 15 }}
          disabled={
            msg.segmentDetailStatus == "VERIFIED" ||
            msg.esignDetailStatus == "VERIFIED" ||
            msg.esignDetailStatus == "PENDING" ||
            msg.segmentDetailStatus == "PENDING"
          }
        />
        {/* {
          segmentFile && segmentFile?.map((v,i) => {
            return(
              <>
              <p key={i}>{v.name}</p>
              <img src={v.name} alt={i} />
              </>
            )
          })
        } */}
        <div className="main_preview">
          <ConfirmDialog
            visible={visible}
            onHide={() => setVisible(false)}
            message="Are you sure you want to Remove?"
            header="Confirmation"
            icon="pi pi-exclamation-triangle"
            accept={delSegmentProofData}
            reject={() => setVisible(false)}
          />
          <div></div>
          {segmentPreview ? (
            <div>
              <span
                className="preview"
                onClick={() => onClick("displayPreview")}
              >
                Click here for Preview old Document
              </span>
            </div>
          ) : null}
        </div>
      </div>
      <div className="seg_upload_doc">
        <Dialog
          onHide={() => onHide("displaySegment")}
          header="Segment Proof"
          visible={displaySegment}
          className="dialog_res"
        >
          <p style={{ fontSize: 12 }}>
            Upload a copy of the {finalWord}
            {/* which shows your Name, Bank
          account number and IFSC code */}
          </p>
          <div className="seg_pop">
            <FileUpload
              name="demo[]"
              multiple="multiple"
              allowTypes="/(pdf|jpe?g|png)$/"
              accept="image/x-png,image/jpeg,application/pdf"
              customUpload={true}
              uploadHandler={invoiceUploadHandler}
              chooseOptions={chooseOptions}
              uploadOptions={uploadOptions}
              cancelOptions={cancelOptions}
              maxFileSize="10240000"
            />
          </div>
        </Dialog>
      </div>
      <Dialog
        onHide={() => onHide("displayPreview")}
        header="Segment Proof Documents"
        visible={displayPreview}
        className="dialog_res"
      >
        <div className="doc_preview">
          {segmentPreview &&
            segmentPreview?.map((v, i) => {
              return (
                <div style={{ display: "flex" }}>
                  {v.split(".").pop() === "pdf" ? (
                    <a href={v} target="_blank">
                      <img src={P} alt="doc" height={30} width={30} key={i} />{" "}
                    </a>
                  ) : (
                    <Image src={v} alt="Image" width="30" height="30" preview />
                  )}
                  <span style={{ marginLeft: 20, fontSize: 13 }}>
                    {segmentName.toLowerCase()}
                  </span>
                </div>
              );
            })}
        </div>
        <Button
          label="Remove All"
          onClick={handleClick}
          className="p-button-raised mr-3 p-button-sm smc_color res_btn w-full"
          disabled={msg.segmentDetailStatus == "VERIFIED"}
        />
      </Dialog>
    </>
  );
};

export default SegmentProof;
